<script lang="ts">
  import { createEventDispatcher } from 'svelte';

  export let size: 'lg' | 'md' | 'sm' = 'md';
  export let selected: boolean = false;
  export let clickable: boolean = true;
  export let green: boolean = false;

  export let corners: boolean = false;

  let dispatch = createEventDispatcher();
</script>

<span
  role="button"
  tabindex="0"
  class="bg-blueish-grey-100 hover:brightness-[.95] font-medium text-blueish-grey-700 text-center cursor-pointer ease-out duration-200 transition-all border border-blueish-grey-100 whitespace-nowrap"
  class:rounded-full={!corners}
  class:pointer-events-none={!clickable}
  class:green
  class:rounded-lg={corners}
  class:md={size === 'md'}
  class:lg={size === 'lg'}
  class:sm={size === 'sm'}
  class:selected
  on:click={() => {
    selected = !selected;
    dispatch('click');
    if (selected) {
      dispatch('select');
    } else {
      dispatch('unselect');
    }
  }}
  on:keydown
>
  <slot />
</span>

<style type="postcss">
  .selected {
    @apply bg-blueish-grey-200 border border-blueish-grey-400;
  }

  .green {
    @apply bg-transparent border border-blueish-grey-400;
  }

  .sm {
    @apply px-[10px] py-1 text-xs;
  }
  .md {
    @apply px-3 py-2 text-sm;
  }

  .lg {
    @apply px-3 py-2 text-base;
  }
</style>
